import { useMemo, useRef } from 'react';
import debounce from 'lodash/debounce';

export const useDebounce = (callback, delay, options = {}) => {
    const callbackRef = useRef(callback);
    callbackRef.current = callback;

    const debouncedFn = useMemo(
        () => debounce((...args) => callbackRef.current(...args), delay, options),
        [delay] // only recreate if delay changes
    );
    return debouncedFn;
};
